// [FROST BUDDY] Fires a `predictive_search_abandoned` dataLayer event when a
// shopper types into the search modal but closes it without submitting.
// Shopify's search reports only log submitted searches (`/search?q=...`), so
// this surfaces the "looked but didn't search" queries in GA4 via GTM.

(() => {
  const MIN_LEN = 3;
  const EVENT_NAME = 'predictive_search_abandoned';

  const input = document.getElementById('cmdk-input');
  const modal = document.getElementById('search-modal');
  const form = input?.closest('form.predictive-search-form');
  if (!input || !modal || !form) return;

  const sent = new Set();
  let lastQuery = '';
  let submitted = false;
  let flushed = false;

  const hasResults = () =>
    !!modal.querySelector(
      '.predictive-search-form__content .predictive-search-results__list, .predictive-search-form__content [data-search-result-index]'
    );

  const flush = () => {
    if (flushed || submitted) return;
    const q = lastQuery.trim();
    if (q.length < MIN_LEN || sent.has(q)) return;
    (window.dataLayer = window.dataLayer || []).push({
      event: EVENT_NAME,
      search_term: q,
      results_present: hasResults(),
    });
    sent.add(q);
    flushed = true;
  };

  input.addEventListener('input', () => {
    lastQuery = input.value;
    flushed = false;
    submitted = false;
  });

  form.addEventListener('submit', () => {
    submitted = true;
  });

  modal.addEventListener('dialog:open', () => {
    lastQuery = input.value;
    submitted = false;
    flushed = false;
  });

  modal.addEventListener('dialog:close', flush);

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') flush();
  });
  window.addEventListener('pagehide', flush);
})();
